const rawApiUrl = import.meta.env.VITE_API_URL as string | undefined;
const rawPwServer = import.meta.env.VITE_PW_SERVER as string | undefined;

if (import.meta.env.PROD) {
  const missing: string[] = [];
  if (!rawApiUrl) missing.push("VITE_API_URL");
  if (!rawPwServer) missing.push("VITE_PW_SERVER");
  if (missing.length > 0) {
    // Fail loudly instead of silently falling back to QA/localhost in prod.
    throw new Error(
      `Missing required Vite environment variables in production build: ${missing.join(
        ", ",
      )}. ` +
        "Provide them via a .env.production file or the CI build environment.",
    );
  }
}

// Dev fallbacks only — production builds require explicit config (see above).
export const API_URL = rawApiUrl || "http://localhost:4000";
export const PW_SERVER = rawPwServer || "https://api-qa.planetwise.io";

/** Shared API base paths — use these instead of inlining "/emission/v1" etc. */
export const EMISSION_BASE = `${PW_SERVER}/emission/v1`;
export const ORGANISATION_BASE = `${PW_SERVER}/organisation/v1`;
export const SRM_BASE = `${PW_SERVER}/srm/v1`;
export const USER_BASE = `${PW_SERVER}/user/v1`;
export const NOTIFICATION_BASE = `${PW_SERVER}/notification/v1`;
export const VERIFY_BASE = `${PW_SERVER}/verify/v1`;
export const ASSET_BASE = `${PW_SERVER}/asset/v1`;
export const MODULE_BASE = `${PW_SERVER}/module/v1`;
export const AUDIT_BASE = `${PW_SERVER}/audit/v1`;
export const SUBSCRIPTION_BASE = `${PW_SERVER}/subscription/v1`;
export const ACCESS_MANAGER_BASE = `${PW_SERVER}/accessmanager`;
export const SECURITY_BASE = `${PW_SERVER}/security/v1`;
